import type { FunctionComponent } from 'react';
import { useEffect, useState } from 'react';

import { config } from '../../../config/config';

import Card from './card/Card';
import './crab-promo-item.scss';

export interface CrabPromoItem {
    className?: string;
}

export const CrabPromoItem: FunctionComponent<CrabPromoItem> = () => {
    const [crabData, setCrabData] = useState([]);
    const token = config.FETCH_DIRECTUS_TOKEN;
    const url = config.FETCH_DIRECTUS_PROMO_ENDPOINT;

    const fetchDirectusData = async () => {
        const response = await fetch(url, {
            headers: {
                Authorization: token,
            },
        });

        const json = await response.json();

        return json.data;
    };

    useEffect(() => {
        const fetchData = async () => {
            const result = await fetchDirectusData();
            setCrabData(result);
        };
        fetchData();
    }, []);

    return (
        <>
            <div className="container-promo">
                <div className="column-cards-promo">
                    <div className="column-cards-container-promo">
                        {crabData &&
                            crabData?.map((e: any, i) => (
                                <div key={`card-${i}`} className="card-item-promo">
                                    <Card
                                        classCard={''}
                                        title={e?.crab_promo_title}
                                        body={e?.crab_promo_body}
                                        href={e?.crab_promo_target}
                                        tandc={e?.crab_promo_tandc}
                                        blank={e?.crab_promo_blank}
                                        image={e?.crab_promos_primary_image?.filename_disk}
                                    />
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </>
    );
};
